import React, { useEffect, useState, useRef, lazy } from "react";
import { Modal, Container } from "react-bootstrap";
import Cookies from "js-cookie";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { clarity } from "clarity-js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from "react-toastify";
import SignIN from "../Components/SignIn";
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState<boolean>(true);

  const handleCloseModal = () => {
    setShowModal(false);
    // window.location.reload();
    const queryParams = location.search;
    navigate(`/${queryParams}`);
  };

  const [searchParams] = useSearchParams();
  const organization_handle = searchParams.get("o");

  useEffect(() => {
    if (process.env.CLARITY_ID && process.env.GA_TRACKING_ID) {
      clarity.setup({
        projectId: process.env.CLARITY_ID as string,
      });
      clarity.initialize(process.env.GA_TRACKING_ID as string);
    }
  }, []);

  useEffect(() => {
    const user = Cookies.get("user");

    user ? setShowModal(false) : setShowModal(true);
  }, [showModal]);

  useEffect(() => {
    const user = Cookies.get("user");
    const userData = user ? JSON.parse(user) : null;

    if (userData && userData.organization_handle !== organization_handle) {
      Cookies.remove("user");
    }

    setShowModal(!user);
  }, [organization_handle]);

  const closeLoading = () => {
    setTimeout(() => {
      //   setIsLoading(false);
    }, 2500);
  };
  useEffect(() => {
    const user = Cookies.get("user");

    user ? setShowModal(false) : setShowModal(true);

    closeLoading();
  }, []);

  return (
    <div>
      <Container fluid className="space-ai-container view-app-container">
        <ToastContainer />
        <Modal
          dialogClassName="sigin-dialog"
          className={showModal ? "signin-model" : ""}
          style={{ background: "#ffffff" }}
          show={showModal}
        >
          <SignIN onCloseModal={handleCloseModal} />
        </Modal>
      </Container>
    </div>
  );
}

export default App;
